export const EmptyScreenStyles = {
  screenContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 230px)",
    textAlign: "center",
    backgroundColor: "#fff",
    padding: 3,
  },
  icon: {
    fontSize: 60,
    color: "#1976D2",
    width: "0.8em",
    height: "0.8em",
  },
  innerContainer: {
    bgcolor: "#eff7ff",
    borderRadius: "50%",
    width: 70,
    height: 70,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontWeight: "bold",
    marginTop: 2,
  },
  subtitle: {
    color: "gray",
    marginTop: 1,
  },
};
